import $$ from 'cmn-utils'
const BaseUrl = "/api/linkage/v2/execute/";
export default {
    list: (params) => {
        return $$.get(BaseUrl + `list`, params);
    },
    delete: (params) => {
        return $$.post(BaseUrl + `delete`, params);
    },
    create: (params) => {
        return $$.post(BaseUrl + `create`, params);
    },
}